import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Table } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';
import { GroupWithInvited } from '../types';
import GroupIncompleteLabel from './GroupIncompleteLabel';

const css = bem('GroupsTable');

type GroupsTableProps = {
  groups: GroupWithInvited[];
  onDetails: (group: GroupWithInvited) => void;
};

const GroupsTable = ({ groups, onDetails }: GroupsTableProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Table fixed selectable unstackable className={css().toString()}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t('group-visits.table.group')}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">{t('group-visits.table.guests')}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            {t('group-visits.table.confirmed')}
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">{t('group-visits.table.refused')}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">{t('group-visits.table.pending')}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {groups.map((group) => {
          const title = group.name || group.inviterName || t('group-visits.card.untitled');
          return (
            <Table.Row
              key={group._id}
              className={css('row', { incomplete: group.isIncomplete }).toString()}
              onClick={() => onDetails(group)}
            >
              <Table.Cell>
                <span className={css('name').toString()}>{title}</span>
                <span className={css('subtitle').toString()}>
                  {group.inviterName && group.name && (
                    <span className={css('inviter').toString()}>
                      <Icon name="user" />
                      {group.inviterName}
                    </span>
                  )}
                  <GroupIncompleteLabel missingFields={group.missingFields} />
                </span>
              </Table.Cell>
              <Table.Cell textAlign="center">{group.totalCount}</Table.Cell>
              <Table.Cell textAlign="center" positive={group.registeredCount > 0}>
                {group.registeredCount}
              </Table.Cell>
              <Table.Cell textAlign="center" negative={group.refusedCount > 0}>
                {group.refusedCount}
              </Table.Cell>
              <Table.Cell textAlign="center" warning={group.pendingCount > 0}>
                {group.pendingCount}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default GroupsTable;
